import { AllCompaniesQuerystring } from "../../../backend/src/routes/company/all.types"
import { DirectoryQuerystring } from "../../../backend/src/routes/company/directory.types"
import { AllUsersQuerystring } from "../../../backend/src/routes/user/all.types"
import { AllSuppliersQuerystring } from "../../../backend/src/routes/supplier/all.types"
import { Querystring as GetPaymentRequestAttachmentQuerystring } from "../../../backend/src/routes/payment-request/getAttachment.types"
import { Querystring } from "../../../backend/src/routes/utils/economySubject.types"
import { AllPaymentRequestsQuerystring } from "../../../backend/src/routes/payment-request/all.types"
import { AllHistoryLogsQuerystring } from "../../../backend/src/routes/history-log/all.types"
import { AllInvoicesQuerystring } from "./invoice/all"
import { GetInvoiceFileQuerystring } from "./invoice/download-file"
import { AvailablePaymentRequestsQuerystring } from "./invoice/available-payment-requests"
import { AllUsersOptionsQuerystring } from "../../../backend/src/routes/user/all-options.types"
import { AllCompaniesOptionsQuerystring } from "../../../backend/src/routes/company/all-options.types"
import { AllSuppliersOptionsQuerystring } from "../../../backend/src/routes/supplier/all-options.types"
import { ArchiveTreeQuerystring } from "../../../backend/src/routes/archive/tree.types"
import { AllArchivesQuerystring } from "./archive/all"
import { AllEventsQuerystring } from "./event/all"

const queryKeys = {
    dashboard: {
        info: () => ["dashboard", "info"],
    },
    company: {
        all: (args?: AllCompaniesQuerystring) => ["companies", args].filter((x) => !!x),
        options: (args?: AllCompaniesOptionsQuerystring) => ["companies-options", args].filter((x) => !!x),
        activityAreas: () => ["companies-activity-areas"],
        forAccounting: () => ["companies-for-accounting"],
        detail: (args?: number) => ["company-detail", args].filter((x) => !!x),
        budgets: (id?: number, year?: number) => ["company-budgets", id, year].filter((x) => !!x),
        budgetsOverview: (year?: number) => ["company-budgets-overview", year].filter((x) => !!x),
        // prefixed with "companies" so every company.all() invalidation refreshes the directory too
        directory: (args?: DirectoryQuerystring) => ["companies", "directory", args].filter((x) => !!x),
    },
    supplier: {
        all: (args?: AllSuppliersQuerystring) => ["suppliers", args].filter((x) => !!x),
        options: (args?: AllSuppliersOptionsQuerystring) => ["suppliers-options", args].filter((x) => !!x),
        detail: (args?: number) => ["supplier-detail", args].filter((x) => !!x),
    },
    users: {
        all: (args?: AllUsersQuerystring) => ["users", args].filter((x) => !!x),
        options: (args?: AllUsersOptionsQuerystring) => ["users-options", args].filter((x) => !!x),
        detail: (args?: number) => ["user-detail", args].filter((x) => !!x),
        profileImage: (id: number) => ["user-profile-image", id],
        me: ["user-info"],
        passwordRecoverInfo: (token: string) => ["password-recover-info", token],
    },
    paymentRequest: {
        all: (args?: AllPaymentRequestsQuerystring) => ["payment-requests", args].filter((x) => !!x),
        detail: (id?: number) => ["payment-request-detail", id].filter((x) => !!x),
        attachment: (id: number, querystring?: GetPaymentRequestAttachmentQuerystring) =>
            ["payment-request-attachment", id, querystring].filter((x) => !!x),
        categories: () => ["payment-requests-categories"],
        approverLogs: (id: number | undefined) => ["payment-request-approver-logs", id].filter((x) => !!x),
        comments: (id: number | undefined) => ["payment-request-comments", id].filter((x) => !!x),
        invoices: (id: number | undefined) => ["payment-request-invoices", id].filter((x) => !!x),
        yearConsumption: (id: number | undefined) => ["payment-request-year-consumption", id].filter((x) => !!x),
    },
    invoice: {
        all: (args?: AllInvoicesQuerystring) => ["invoices", args].filter((x) => !!x),
        detail: (id?: number) => ["invoice-detail", id].filter((x) => !!x),
        metadata: (id?: number) => ["invoice-metadata", id].filter((x) => !!x),
        paymentRequests: (id: number, querystring?: AvailablePaymentRequestsQuerystring) =>
            ["invoice-payment-requests", id, querystring].filter((x) => !!x),
        file: (id?: number, querystring?: GetInvoiceFileQuerystring) =>
            ["invoice-file", id, querystring].filter((x) => !!x),
        attachmentFile: (id?: number, attachmentId?: number) =>
            ["invoice-attachment-file", id, attachmentId].filter((x) => !!x),
        comments: (id: number | undefined) => ["invoice-comments", id].filter((x) => !!x),
    },
    historyLog: {
        all: (args: AllHistoryLogsQuerystring) => ["history-logs", args].filter((x) => !!x),
    },
    event: {
        all: (args?: AllEventsQuerystring) => ["events", args].filter((x) => !!x),
    },
    utils: {
        economySubjectInfo: (args: Querystring) => ["economy-subject-info", args],
        systemInfo: () => ["system-info"],
        systemStatus: () => ["system-status"],
        systemStatusList: () => ["system-status", 'list'],
        taskRunHistory: (key?: string) => ["task-run-history", key].filter((x) => !!x),
        versionInfo: (version: string) => ["version-info", version],
    },
    archive: {
        all: (args?: AllArchivesQuerystring) => ["archives", args].filter((x) => !!x),
        treeLevel: (args?: ArchiveTreeQuerystring) => ["archive-tree-level", args].filter((x) => !!x),
        treeLevelDetail: (id?: number) => ["archive-tree-level-detail", id].filter((x) => !!x),
    },
}
export default queryKeys
